import { render, staticRenderFns } from "./mobile-instruction.vue?vue&type=template&id=7d510756"
import script from "./mobile-instruction.vue?vue&type=script&lang=js"
export * from "./mobile-instruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/mobile-instruction/mobile-instruction.vue
// module id = sWHG
// module chunks = 0